import { render, staticRenderFns } from "./bidderFlow.vue?vue&type=template&id=ed640d34&scoped=true"
import script from "./bidderFlow.vue?vue&type=script&lang=js"
export * from "./bidderFlow.vue?vue&type=script&lang=js"
import style0 from "./bidderFlow.vue?vue&type=style&index=0&id=ed640d34&prod&lang=less&scoped=true"
import style1 from "./bidderFlow.vue?vue&type=style&index=1&id=ed640d34&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed640d34",
  null
  
)

export default component.exports